import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Tooltip from 'rc-tooltip';
import RFID from '../common/icons/Assets/RFID/RFID';
import _ from 'lodash';
import {
  fetchUsers,
  inviteUser,
  changeSort,
  changeFilter,
  deleteUser,
  changeRole,
  removeAccess,
  clearStateOnPage,
  clearEdits,
} from 'redux/modules/duck-admin';
import {
  fetchAdminUserLog,
  changeLogSort,
  resetLogSort,
} from 'redux/modules/duck-parcels';
import {
  changeRoleNoti,
  removeUserNoti,
  cancelInviteNoti,
} from 'utils/notiOptions';
import { success, warning } from 'react-notification-system-redux';

import Invitation from './Invitation';
import AddRfid from './AddRfid';

import LogTable from 'common/LogTable';
import LoaderPage from 'common/LoaderPage';
import LongButton from 'common/buttons/longButton';
import SvgIcon from 'common/icons/SvgIcon';

import colors from 'utils/colors';
import { baseFont, boldFont } from 'utils/fonts';
import Spinner from 'common/Spinner';
import { belowFourHeight, belowfour } from 'utils/media';
import GetTableSize from 'utils/getTableSize';

//version of PL that could be regular or retail
const pLVersion = process.env.REACT_APP_PL_VERSION || 'retail';

const Loader = styled(Spinner)`
  margin: 0 auto;
`;

const Wrapper = styled.div`
  width: auto;
  box-sizing: border-box;
  overflow-y: auto;
`;

const NA = styled.div`
  min-height: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 30px;
  color: ${colors.primary_blue};
  font-family: ${boldFont};
`;

const InputWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 150px;
`;

const FilterBar = styled.input`
  float: left;
  width: 60%;
  height: 28px;
  padding-left: 40px;
  font-size: 18px;
  line-height: 21px;
  font-family: ${baseFont};
  border: none;
  border-bottom: 1px solid rgba(51, 51, 51, 0.3);
  transition: all 350ms ease-in-out;
  &::placeholder {
    font-size: 18px;
    line-height: 21px;
    font-family: ${baseFont};
    color: ${colors.primary_gray};
    opacity: 0.35;
    transition: opacity 150ms ease-in-out;
  }
  &:focus {
    outline: none;
    + span {
      &:after {
        width: 100%;
      }
    }
    &::placeholder {
      opacity: 0.1;
    }
  }
  + span {
    float: left;
    width: calc(60% + 40px);
    &:after {
      margin-top: -1px;
      z-index: 999;
      display: block;
      content: '';
      border-bottom: 2px solid ${colors.base_text3};
      width: 0;
      transition: width 250ms ease-in-out;
    }
  }
`;

const InviteModalButton = styled(LongButton)`
  float: right;
  width: 155px;
  height: 33px;
  font-size: 14px;
  margin-top: -30px;
  @media (max-width: 580px) {
    float: left;
    margin-top: 0;
  }
`;

const BlueButton = styled(LongButton)`
  min-width: 75px;
  max-width: 225px;
  width: 100%;
  height: 35px;
  font-size: 16px;
  transition: all 0.3s ease-in-out;
`;

const InviteButton = styled(LongButton)`
  min-width: 35px;
  width: 125x;
  margin: auto 5px;
  font-size: 16px;
  transition: all 0.3s ease-in-out;
`;

const CancelButton = styled(LongButton)`
  min-width: 35px;
  width: 125x;
  margin: auto 5px;
  font-size: 16px;
`;

const ModifyArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 15px;
  max-width: 265px;
  margin: 0 auto;
`;

const Cancel = styled.h2`
  ${belowFourHeight(css`
    font-size: 18px;
  `)};
  ${belowfour(css`
    font-size: 18px;
  `)};
`;

const RoleWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Role = styled.h2`
  font-weight: bolder;
`;

const SelectWrapper = styled.div`
  width: 100%;
`;

const SelectWrap = styled.div`
  position: relative;
  :after {
    content: '';
    position: absolute;
    top: 50%;
    right: 70px;
    margin-top: -3px;
    border-width: 6px;
    border-style: solid;
    border-color: ${colors.base_text3} transparent transparent;
  }
`;

const SelectField = styled.select`
  width: 100%;
  padding: 0 !important;
  font-size: 14px;
  font-family: ${baseFont};
  color: #333333;
  background: transparent;
  border-color: transparent;
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
`;

const OptionSelect = styled.option`
  color: ${colors.action2};
`;

const Title = styled.h1`
  font-size: 24px;
  color: ${colors.base_text3};
  font-family: ${baseFont};
  line-height: 22px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 50px;
  align-self: flex-start;
`;

const ReinviteButton = styled.button`
  cursor: pointer;
  font-family: ${baseFont};
  color: ${colors.base_text3};
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.51px;
  border: none;
  background: transparent;
`;

const CloseButton = styled.span`
  fontfamily: Arial;
  lineheight: 15px;
  cursor: pointer;
  color: ${(p) => colors[p.color] || colors.base_text3};
  fontweight: 300;
  width: 14px;
  height: 14px;
  fontsize: 17px;
`;

const PaginationButton = styled.button`
  color: ${colors.base_text3};
  font-family: ${baseFont};
  font-size: 14px;
  letter-spacing: 0.71px;
  line-height: 18px;
  border: none;
`;

class Manage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      showModal: false,
      showInvitationModal: false,
      targetUserEmail: '',
      search: '',
      showRfidModal: false,
    };

    this.handleFilter = this.handleFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.resendInvite = this.resendInvite.bind(this);
    this.resetTable = this.resetTable.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggleInvitationModal = this.toggleInvitationModal.bind(this);
    this.toggleRfidModal = this.toggleRfidModal.bind(this);
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
  }

  resetTable() {
    this.props.changeSort('email', 'first_name', this.props.ascending);
  }

  componentDidMount() {
    ReactModal.setAppElement('body');
    if (localStorage.user_token && this.props.selectedSystem) {
      this.props.fetchUsers(
        this.props.selectedSystem.system._id,
        this.props.history
      );
    }
  }

  componentDidUpdate() {
    if (this.props.editSuccess || this.props.rfidSuccess) {
      if (localStorage.user_token && this.props.selectedSystem) {
        this.props.fetchUsers(
          this.props.selectedSystem.system._id,
          this.props.history
        );
        this.props.clearEdits();
      }
    }
  }

  componentWillUnmount() {
    this.props.changeFilter('');
  }

  handleFilter(e) {
    const input_v = e.currentTarget.value.toLowerCase();
    this.setState({ search: input_v });
  }

  clearFilter() {
    this.props.changeFilter('');
    this.filter.value = '';
    this.setState({ search: '' });
  }

  resendInvite(emails) {
    this.props.inviteUser({
      emails,
      company: this.props.current_user._company,
    });
  }

  openLogs(user_id) {
    this.props.fetchAdminUserLog(
      user_id,
      this.props.selectedSystem.system._id,
      this.props.history
    );
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  closeModal() {
    this.props.resetLogSort();
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  toggleRfidModal(user) {
    this.props.clearStateOnPage();
    if (user) {
      this.setState({
        showRfidModal: !this.state.showRfidModal,
        user: user,
      });
    } else {
      this.setState({ showRfidModal: !this.state.showRfidModal });
    }
  }

  toggleInvitationModal() {
    this.setState({
      showInvitationModal: !this.state.showInvitationModal,
    });
  }

  closeConfirmationModal() {
    this.setState({
      showConfirmationModal: !this.state.showConfirmationModal,
    });
  }

  renderButtons(user, deleting) {
    return (
      <ModifyArea>
        <ReinviteButton
          onClick={(e) => {
            e.currentTarget.textContent = 'SENT';
            e.currentTarget.style.color = '#90A1B5';
            e.currentTarget.setAttribute('disabled', 'disabled');
            this.resendInvite(user.email);
          }}
        >
          REINVITE
        </ReinviteButton>
        <CloseButton
          color="action2"
          onClick={() => {
            this.props.cancelInvitePopUp(user.email, user._id);
          }}
        >
          x
        </CloseButton>
      </ModifyArea>
    );
  }

  render() {
    const {
      managers_table_loading,
      loading,
      parcels,
      logs,
      changeLogSort,
      history,
      current_user,
      match,
      users,
      selectedSystem,
      profile,
    } = this.props;

    // Set the table size without blank rows.
    let filterUsers = users;
    const { pageStart, pageSizeArray } = GetTableSize(users.length);

    // Search feature
    if (this.state.search) {
      filterUsers = users.filter((row) => {
        // Filter by email
        if (row.email.includes(this.state.search)) {
          return row;
        }

        // Filter by full name
        if (row.first_name) {
          // Skip pending user by checking first name existence
          const fullName = `${row.first_name} ${row.last_name}`.toLowerCase();
          if (fullName.includes(this.state.search)) {
            return row;
          }
        }

        // Filter by status
        if (
          ('pending'.includes(this.state.search) &&
            row.status === 'reactivate') ||
          row.status.includes(this.state.search)
        ) {
          return row;
        }

        if ('active'.includes(this.state.search) && row.status === 'active') {
          return row;
        }

        // Filter by role
        if ('owner'.includes(this.state.search) && row.user_role === 1) {
          return row;
        }

        if ('admin'.includes(this.state.search) && row.user_role === 2) {
          return row;
        }

        if ('user'.includes(this.state.search) && row.user_role === 3) {
          return row;
        }
      });
    }

    const columns = [
      {
        Header: 'Name',
        headerClassName: 'table-header',
        width: 150,
        className: 'table-cell',
        Cell: ({ row }) => {
          const user = row._original;
          const fullName = `${user.first_name} ${user.last_name}`;

          if (user.first_name) {
            return fullName;
          } else {
            return '';
          }
        },
        accessor: 'first_name',
        sortMethod: (a, b, desc) => {
          if (desc) {
            if (a && !b) {
              return 1;
            }

            if (!a && b) {
              return -1;
            }

            if (!a && !b) {
              return 0;
            }

            if (a && b && a[0] > b[0]) {
              return 1;
            }

            if (a && b && a[0] < b[0]) {
              return -1;
            }

            return 0;
          } else {
            if (a && !b) {
              return -1;
            }

            if (!a && b) {
              return 1;
            }

            if (!a && !b) {
              return 0;
            }

            if (a && b && a[0] > b[0]) {
              return 1;
            }

            if (a && b && a[0] < b[0]) {
              return -1;
            }

            return 0;
          }
        },
      },
      {
        Header: 'Email',
        headerClassName: 'table-header',
        className: 'table-cell',
        accessor: 'email',
        width: 250,
        sortMethod: (a, b) => {
          if (a < b) {
            return -1;
          }

          if (a > b) {
            return 1;
          }

          return 0;
        },
      },
      ...(pLVersion !== 'retail'
        ? {
            Header: 'RFID',
            headerClassName: 'table-header',
            className: 'table-cell',
            width: 100,
            style: {
              textAlign: 'center',
              justifyContent: 'center',
            },
            Cell: ({ row }) => {
              const user = row._original;
              if (
                user.rfid &&
                (user.rfid !== 'pending' ||
                  (profile && user._id === profile._id))
              ) {
                return (
                  <span>
                    <RFID
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.toggleRfidModal(user)}
                    />
                  </span>
                );
              } else {
                return (
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.toggleRfidModal(user)}
                  >
                    ADD+
                  </span>
                );
              }
            },
            accessor: 'RFID',
          }
        : {}),

      {
        Header: 'Status',
        headerClassName: 'table-header',
        className: 'table-cell',
        width: 150,
        Cell: ({ row }) => {
          const user = row._original;
          if (
            user.status === 'reactivate' ||
            user.status === 'verify' ||
            user.status === 'set_pin'
          ) {
            return 'PENDING';
          } else {
            return user.status ? user.status.toUpperCase() : null;
          }
        },
        accessor: 'status',
      },
      {
        Header: 'Role',
        headerClassName: 'table-header',
        className: 'table-cell table-col-timestamp',
        accessor: 'user_role',
        sortMethod: (a, b) => {
          if (a < b) {
            return -1;
          }

          if (a > b) {
            return 1;
          }
        },
        minWidth: 115,
        Cell: ({ row }) => {
          const user = row._original;

          const { user_role } = user;

          // owner perspective - ability to change roles
          // and also user cannot edit own role
          if (this.props.selectedSystem.level === 1) {
            if (user_role !== 1) {
              const fullName = user.first_name
                ? `${user.first_name} ${user.last_name}`
                : user.email;

              return (
                <SelectWrapper>
                  <SelectWrap>
                    {pLVersion !== 'retail' ? (
                      <SelectField
                        value={user_role}
                        onChange={(e) => {
                          let role = e.currentTarget.value;
                          e.currentTarget.value = user_role;
                          this.props.changeRolePopUp(
                            fullName,
                            role,
                            user._access
                          );
                        }}
                      >
                        <OptionSelect value={2}>Admin</OptionSelect>
                        <OptionSelect value={3}>User</OptionSelect>
                      </SelectField>
                    ) : (
                      <SelectField
                        value={user_role}
                        onChange={(e) => {
                          let role = e.currentTarget.value;
                          e.currentTarget.value = user_role;
                          this.props.changeRolePopUp(
                            fullName,
                            role,
                            user._access
                          );
                        }}
                      >
                        <OptionSelect value={1}>Owner</OptionSelect>
                        <OptionSelect value={2}>Admin</OptionSelect>
                      </SelectField>
                    )}
                  </SelectWrap>
                </SelectWrapper>
              );
            } else {
              return (
                <div style={{ left: '30px', textAlign: 'center' }}>
                  {pLVersion !== 'retail' ? 'OWNER' : 'EXECUTIVE'}
                </div>
              );
            }
          } else {
            if (user.user_role == 3) {
              return 'USER';
            } else if (user.user_role == 2) {
              return 'ADMIN';
            } else if (user.user_role == 1) {
              return <b style={{ color: 'red' }}>OWNER</b>;
            }
          }
        },
      },
      {
        Header: 'Log',
        headerClassName: 'table-header nounderline',
        accessor: 'label_url',
        className: 'table-cell label-column',
        sortable: false,
        Cell: ({ row }) => {
          const user = row._original;
          const active = (user && user.status === 'active') || false;
          if (active) {
            return (
              <span
                style={{
                  cursor: 'pointer',
                  color: colors.base_text3,
                  fontWeight: 'bold',
                }}
                onClick={() => this.openLogs(user._id)}
              >
                VIEW
              </span>
            );
          }

          return null;
        },
      },
      {
        Header: 'Action',
        headerClassName: 'table-header nounderline',
        className: 'table-cell label-column',
        sortable: false,
        width: 150,
        accessor: 'action',
        style: { textAlign: 'left' },
        Cell: ({ row }) => {
          const user = row._original;

          const active = user.status === 'active';

          if (
            // Current user is an Owner and can remove anyones access
            ((this.props.selectedSystem.level === 1 && active) || // Current user is an Admin and can remove user access
              (this.props.selectedSystem.level === 2 &&
                active &&
                user.user_role === 3)) &&
            // Current user isn't themselves
            current_user._id !== user._id
          ) {
            const fullName = `${user.first_name} ${user.last_name}`;
            return (
              <ModifyArea>
                <span
                  style={{
                    cursor: 'pointer',
                    color: colors.action2,
                    fontSize: '12px',
                    paddingLeft: '8px',
                  }}
                  onClick={() => {
                    this.props.removeUserPopUp(fullName, user._access);
                  }}
                >
                  REMOVE
                </span>
              </ModifyArea>
            );
          } else if (
            user.status === 'pending' ||
            user.status === 'reactivate'
          ) {
            return this.renderButtons(user, loading);
          }

          return null;
        },
      },
    ];

    return this.props.selectedSystem ? (
      <div
        style={{
          width: '100%',
          padding: '15px',
          boxSizing: 'border-box',
        }}
      >
        <Title>Manage Users</Title>
        <InputWrapper>
          <SvgIcon
            height="18px"
            width="18px"
            fill={colors.base_text3}
            icon="search"
            viewBox="0 0 18 18"
            style={{
              position: 'absolute',
              float: 'left',
              paddingTop: '5px',
            }}
          />
          <FilterBar
            onChange={this.handleFilter}
            type="text"
            innerRef={(ref) => (this.filter = ref)}
            placeholder="Search People"
          />
          <span />
          <InviteModalButton
            backgroundColor="accent1"
            textColor="base2"
            onClick={() => this.toggleInvitationModal()}
          >
            Invite +
          </InviteModalButton>
        </InputWrapper>
        <Wrapper>
          {managers_table_loading ? (
            <LoaderPage color="accent1" />
          ) : filterUsers.length === 0 && !managers_table_loading ? (
            <NA>No Users yet!</NA>
          ) : (
            <ReactTable
              data={filterUsers}
              columns={columns}
              noDataText=""
              className="table -highlight"
              defaultPageSize={pageStart}
              pageSizeOptions={pageSizeArray}
              defaultSorted={[{ id: 'email' }]}
              minRows={0}
              loading={managers_table_loading}
              loadingText="Loading..."
              resizable={false}
              rowsText={null}
              PreviousComponent={(props) => {
                return (
                  <div>
                    <PaginationButton
                      {...props}
                      style={{
                        color: props.disabled
                          ? colors.accent4
                          : colors.base_text3,
                      }}
                    >
                      PREV
                    </PaginationButton>
                  </div>
                );
              }}
              NextComponent={(props) => {
                return (
                  <PaginationButton
                    {...props}
                    style={{
                      color: props.disabled
                        ? colors.accent4
                        : colors.base_text3,
                    }}
                  >
                    NEXT
                  </PaginationButton>
                );
              }}
            />
          )}
        </Wrapper>
        <ReactModal
          className="Modal LogModal"
          overlayClassName="Overlay"
          closeTimeoutMS={150}
          isOpen={this.state.showModal}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
        >
          <LogTable
            parcels={parcels}
            log_loading={logs.log_loading}
            changeLogSort={changeLogSort}
          />
        </ReactModal>
        <ReactModal
          className="Modal"
          overlayClassName="Overlay"
          closeTimeoutMS={150}
          isOpen={this.state.showInvitationModal}
          onRequestClose={this.toggleInvitationModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
        >
          <CloseButton
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              fontSize: '30px',
            }}
            onClick={() => this.toggleInvitationModal()}
          >
            x
          </CloseButton>
          <Invitation />
        </ReactModal>
        <ReactModal
          className="Modal RfidModal"
          overlayClassName="Overlay"
          closeTimeoutMS={150}
          isOpen={this.state.showRfidModal}
          onRequestClose={this.toggleRfidModal}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
        >
          <CloseButton
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              fontSize: '30px',
            }}
            onClick={() => this.toggleRfidModal()}
          >
            x
          </CloseButton>
          <AddRfid
            user={this.state.user}
            selectedSystem={this.props.selectedSystem}
          />
        </ReactModal>
      </div>
    ) : (
      <Loader />
    );
  }
}

function mapStateToProps({ admin, auth, parcels }) {
  const current_user = auth.user;
  const { users, loading, profile, editSuccess, rfidSuccess } = admin;
  const { log_parcels } = parcels;
  const { managers_table_loading, ascending, sortBy, selectedSystem } = admin;
  return {
    loading,
    users,
    current_user,
    managers_table_loading,
    ascending,
    sortBy,
    parcels: log_parcels,
    logs: {
      log_loading: parcels.log_loading,
      log_user_id: parcels.log_user_id,
    },
    selectedSystem,
    profile,
    editSuccess,
    rfidSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchUsers,
      inviteUser,
      changeSort,
      clearStateOnPage,
      clearEdits,
      changeFilter,
      fetchAdminUserLog,
      changeLogSort,
      resetLogSort,
      deleteUser,
      changeRole,
      removeAccess,
      changeRolePopUp: (name, role, _access) =>
        success(changeRoleNoti(name, role, _access)),
      removeUserPopUp: (name, _access) =>
        warning(removeUserNoti(name, _access)),
      cancelInvitePopUp: (email, _user) =>
        warning(cancelInviteNoti(email, _user)),
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Manage);



// WEBPACK FOOTER //
// ./src/Admin/Manage.js